import { Component, OnInit, Input, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Apiservice } from '../../services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DxChartComponent, DxPieChartComponent } from 'devextreme-angular';
import { alert, confirm } from 'devextreme/ui/dialog';
import { ComponentService } from '../../services/component.service';
import { NewNicaFormComponent } from '../nica-form/new-nica-form.component';

interface DatiChart {
  argumentField: string | null;
  dataStored?: any[] | null;
  idStatoFisico?: number | null;
  statoFisico_Iniziali?: string | null;
  statoFisico_Descrizione?: string | null;
  isUrbano?: string | boolean | null;
  riferimentoEER?: string | null;
  EER: string | null;
  dataRegistrazione?: string | null;
  idCliente?: string | null;
  cliente_Descrizione?: string | null;
  idProduttore?: string | null;
  produttore_Descrizione_Soggetto?: string | null;
  produttore_Descrizione_Sede?: string | null;
  idTrasportatore?: string | null;
  trasportatore_Descrizione_Soggetto?: string | null;
  idDestinatario?: string | null;
  destinatario_Descrizione_Soggetto?: string | null;
  quantitaPercent?: number | null;
  quantita: any;
}

interface ResponseOdata {
  totalCount: number | null;
  items: DatiChart[];
}

interface OptionGroup {
  key: string;
  label: string;
}

interface DateRegistrazioni {
  day: number;
  month: number;
  year: number;
}

@Component({
  selector: 'app-widget-grafici',
  templateUrl: './widget-grafici.component.html',
  styleUrls: ['./widget-grafici.component.css'],
})
export class WidgetGraficiComponent implements OnInit {
  @Input() urlOdata: string; //url per la chiamata api di odata
  @Input() statistica: number; //tipo di statitistica selezionata prima del grafico
  @ViewChild(DxChartComponent, { static: false }) chart: DxChartComponent; //grafico
  @ViewChild(DxPieChartComponent, { static: false }) pieChart: DxChartComponent; //grafico a torta
  dettagli: string = ''; //sottotitolo del grafico in dxTitle per dettagli custom lunghi
  titoloChart: string = ''; //titolo del grafico in dxo-title
  subTitleLegend: string = ''; //titolo della legenda in dxLegend dxTitle
  chartDataSource: DatiChart[] = []; //dati da passare al grafico per render statistiche
  selectedChartType: string = 'bar'; //tipo di grafico da visualizzare
  selectedExportOption: string = 'PDF'; //tipo di file da esportare per grafico
  selectWeightUnity: string = 'kg'; //unità di misura del peso da visualizzare
  rangeMaxQuantita: number = 0; //valore massimo di valueAxis per grafico
  dataObject: { [key: string]: DatiChart } = {}; //oggetto dati generato da api con chiave valore
  isData: boolean = true; //variabile controlo se dati presenti
  isMonthUguali: boolean = false; //variabile per sapere se i mesi selezionati sono uguali
  totQuantitaKg: number; //variabile per il totale delle quantita
  legendVisibile: boolean = true; //variabile per nascondere o visualizzare la leggenda
  showDynamicPopOver = false;
  readonly chartOptions: OptionGroup[] = [
    { key: 'bar', label: 'Barre' },
    { key: 'pie', label: 'Torta' },
  ]; //opzioni per select tipo grafico
  readonly exportOption: OptionGroup[] = [
    { key: 'PDF', label: 'PDF' },
    { key: 'SVG', label: 'SVG' },
    { key: 'PNG', label: 'PNG' },
    { key: 'JPEG', label: 'JPEG' },
  ]; //opzioni per select tipo file esportazione
  readonly weightOptions: OptionGroup[] = [
    { key: 'kg', label: 'Chilogrammi' },
    { key: 't', label: 'Tonnellate' },
  ]; //opzioni per select unità di misura quantità peso
  readonly mesi: string[] = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']; //mesi per generazioni mesi vuoti dati grafico

  constructor(public apiservice: Apiservice, private cdr: ChangeDetectorRef, private spinner: NgxSpinnerService, private userComponentService: ComponentService) { }

  ngOnInit() {
    //chiamo l'api dei dati
    this.getApiData(this.urlOdata);
    //this.chartDataSource = this.generateFakeData();
    //console.log(this.chartDataSource);
    this.generaTitolo();
  }
  /*    generateFakeData(count = 20) {
     // Funzione per generare l'argumentField con un pattern specifico
     function generateArgumentField(dayNumber) {
        const weight = Math.floor(Math.random() * 51); // Peso casuale tra 0 e 50 Kg
        return `Gioveddddddddddddddddd dddì ${dayNumber} - ${weight} Kg`;
     }
     // Generazione dei dati
     return Array.from({ length: count }, (_, index) => ({
        EER: null,
        argumentField: generateArgumentField(index + 1),
        cliente_Descrizione: null,
        dataRegistrazione: null,
        destinatario_Descrizione_Soggetto: null,
        idCliente: null,
        idDestinatario: null,
        idProduttore: null,
        idStatoFisico: null,
        idTrasportatore: null,
        isUrbano: null,
        produttore_Descrizione_Soggetto: null,
        quantita: Math.floor(Math.random() * 10001),
        quantitaPercent: 0,
        riferimentoEER: null,
        statoFisico_Descrizione: null,
        statoFisico_Iniziali: null,
        trasportatore_Descrizione_Soggetto: null,
     }));
  } */
  //!-------------------------------------------- DX FUNCTION FOR CHART ----------------------------------------------------
  generaTitolo() {
    //creo costante titolo estratto da orderBy e processato in testo
    const orderByTitoli = this.processOrderByTitle(this.estraiOrderBy());
    const date: DateRegistrazioni[] = this.estraiDataRegistrazione();
    let titoloGenerato = '';
    if (orderByTitoli !== '') {
      titoloGenerato += ` - Distinte per: ${orderByTitoli}`;
    }
    if (this.statistica === 4) {
      if (date[0].month === date[1].month) {
        titoloGenerato += ` ( Mese: ${this.mesi[date[0].month - 1]}, Anno: ${date[0].year} )`;
      } else {
        titoloGenerato += ` ( Anno: ${date[0].year} )`;
      }
    } else {
      let daData = `Dal: ${date[0].day}/${date[0].month}/${date[0].year}`;
      let aData = `Al: ${date[1].day}/${date[1].month}/${date[1].year}`;
      titoloGenerato += ` ( ${daData} ${aData} )`;
    }
    this.titoloChart = `Statistiche Rifiuti${titoloGenerato}`;
  }
  /**
   * Resetta il grafico, ripristinando l'intervallo visivo e aggiornando il grafico.
   * Se il grafico è di tipo torta (pie/doughnut), viene aggiornato solo.
   * @returns {void}
   */
  resetChart(): void {
    if (this.chart) {
      this.chart.instance.resetVisualRange();
      this.chart.instance.refresh();
    }
    if (this.pieChart) {
      this.pieChart.instance.refresh();
    }
    return;
  }
  /**
   * Stampa il grafico selezionato in base al tipo di grafico attuale (pie, doughnut o altro).
   * @returns {void}
   */
  onPrintClick(): void {
    switch (this.selectedChartType) {
      case 'pie':
        return this.pieChart.instance.print();
      default:
        return this.chart.instance.print();
    }
  }
  /**
   * Esporta il grafico selezionato in un formato file specifico.
   * Il nome del file viene derivato dal titolo del grafico, con spazi sostituiti da trattini.
   * @returns {void}
   */
  onExportClick(): void {
    switch (this.selectedChartType) {
      case 'pie':
        return this.pieChart.instance.exportTo(this.titoloChart, this.selectedExportOption.toLocaleLowerCase());
      default:
        return this.chart.instance.exportTo(this.titoloChart, this.selectedExportOption.toLocaleLowerCase());
    }
  }
  /**
   * Aggiorna il tipo di grafico selezionato e forza un refresh del DOM.
   * @returns {void}
   */
  onChartTypeChange(): void {
    return this.cdr.detectChanges();
  }
  /**
   * Cambia l'unità di peso visualizzata nel grafico (Kg o tonnellate) e ricalcola le quantità.
   * Modifica il sottotitolo del grafico e aggiorna i dati.
   * Modifica il titolo di argumentField
   * @returns {void}
   */
  onWeightUnityChange(): void {
    if (this.selectWeightUnity === 't') {
      this.chartDataSource.forEach((dato: DatiChart) => {
        if (dato.quantita !== null) {
          dato.quantita = parseFloat((Number(dato.quantita) / 1000).toPrecision(5));
        }
        let argument = dato.argumentField.split(' - ');
        argument[argument.length - 1] = `${dato.quantita !== null ? dato.quantita.toLocaleString('it-IT') : 0} T`;
        dato.argumentField = `${argument.join(' - ')}`;
      });
      this.calcolaTot();
    } else {
      this.chartDataSource.forEach((dato: DatiChart) => {
        if (dato.quantita !== null) {
          dato.quantita = parseFloat((Number(dato.quantita) * 1000).toPrecision(5));
        }
        let argument = dato.argumentField.split(' - ');
        argument[argument.length - 1] = `${dato.quantita !== null ? dato.quantita.toLocaleString('it-IT') : 0} Kg`;
        dato.argumentField = `${argument.join(' - ')}`;
      });
      this.calcolaTot();
    }
    return this.cdr.detectChanges();
  }
  /**
   * Determina il formato dei valori numerici in base all'unità di peso selezionata.
   * @returns {string} Il formato numerico ("decimal" per tonnellate, "largeNumber" per Kg).
   */
  typeFormat(): string {
    switch (this.selectWeightUnity) {
      case 't':
        return 'decimal';
      default:
        return 'largeNumber';
    }
  }
  /**
   * Gestisce il click su una legenda, attivando o disattivando la visibilità della serie associata.
   * @param {Object} param - Parametro contenente la serie associata.
   * @returns {void}
   */
  legendClick({ target: series }): void {
    return this.toggleVisibility(series);
  }
  /**
   * Personalizza il testo visualizzato nelle etichette dei grafici.
   * Mostra il valore e la percentuale del segmento.
   * @param {Object} event - Evento che contiene i dettagli della serie.
   * @returns {string} Testo personalizzato per l'etichetta.
   */
  customizeTextLabel(event): string {
    //    console.log(event);
    return `${event.percentText}`;
  }
  /**
   * Personalizza il testo visualizzato negli argument dei grafici.
   * Mostra il valore del segmento.
   * @param {object} data - Evento che contiene i dettagli dell'argument.
   * @returns {string} Testo personalizzato per l'etichetta.
   */
  customizeTextArgument(data) {
    //console.log(data)
    let argument = data.valueText.split(' - ');
    if (argument.length > 1) {
      argument.pop();
    }
    return argument.join(' - ');
  }
  /**
   * Gestisce il click sulla legenda di un grafico a torta, attivando/disattivando la visibilità di un punto.
   * @param {Object} event - Evento associato al click.
   * @returns {void}
   */
  legendClickForPie(event): void {
    const arg = event.target;
    const item = event.component.getAllSeries()[0].getPointsByArg(arg)[0];
    return this.toggleVisibility(item);
  }
  /**
   * Mostra il tooltip associato a un punto del grafico al click.
   * @param {Object} param - Contiene il punto target.
   * @returns {void}
   */
  onPointClick(event): void {
    console.log(event.target.data);
    event.target.hideTooltip();
    return this.popUpGrid(event.target.data);
  }
  /**
   * Alterna la visibilità di un elemento del grafico.
   * @param {Object} item - L'elemento di cui alternare la visibilità.
   * @returns {void}
   */
  toggleVisibility(item): void {
    if (item.isVisible()) {
      return item.hide();
    } else {
      return item.show();
    }
  }
  /**
   * Determina il campo `argumentField` dinamico in base alla statistica selezionata.
   * @returns {string} Il campo da utilizzare come `argumentField`.
   */
  dynamicArgument(): string {
    if (this.statistica === 2 || this.statistica === 3) {
      return 'EER';
    } else {
      return 'argumentField';
    }
  }
  /**
   * Personalizza il testo della legenda in base alla serie o al punto selezionato.
   * Filtra e rimuove valori non desiderati come "true", "false" e "void".
   * @param {Object} event - Evento contenente i dettagli della legenda.
   * @returns {string} Testo personalizzato per la legenda.
   */
  customizeTextLegend(event): string {
    let legendTexts = event.seriesName ? event.seriesName.split('/') : event.pointName.split('/');
    legendTexts = legendTexts.map((text: string) => {
      if (['true', 'false'].includes(text)) return '';
      return text;
    });
    return legendTexts.filter((text) => text !== '').join('/');
  }
  /**
   * Personalizza il tooltip per i dati del grafico.
   * Rimuove valori non desiderati come "true", "false" e "void" dall'`argumentField`.
   * @param {DatiChart} data - Dati associati al punto del grafico.
   * @returns {DatiChart} Dati con `argumentField` personalizzato.
   */
  customizeToolTip(data: DatiChart): DatiChart {
    let argumentField = data.argumentField.split('/');
    let quantita = data.quantita.toLocaleString('it-IT');
    //console.log(quantita)
    argumentField = argumentField.map((text: string) => {
      if (['true', 'false', 'void'].includes(text)) return '';
      return text;
    });
    data.argumentField = argumentField[0];
    data.quantita = quantita;
    return data;
  }
  /**
   * Capitalizza la prima lettera di una stringa.
   * @param {string} str - La stringa da capitalizzare.
   * @returns {string} La stringa con la prima lettera maiuscola.
   */
  capitalize(str: string): string {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  /**
   * Calcola il totale delle quantità in base all'unità di misura selezionata (Tonnellato, Chilogrammi) e la insiresce in subTitleLegend
   * @returns {void}
   */
  calcolaTot(): void {
    switch (this.selectWeightUnity) {
      case 't':
        this.subTitleLegend = ` Quantità totale: ${(this.totQuantitaKg / 1000).toLocaleString('it-IT')} T`;
        break;
      default:
        this.subTitleLegend = ` Quantità totale: ${(this.totQuantitaKg * 1000).toLocaleString('it-IT')} Kg`;
        break;
    }
  }
  popUpForm() {
    const guida = Math.random().toString().replace('0.', '');
    let instancedData = {
      service: 'graficoCommento',
      api: '',
      filterKey: '',
      queryString: '',
      type: 'simpleForm',
      nCol: 1,
      remoteOperation: false,
      toolbarTop: false,
      toolbarBottom: true,
      CustomButtonSetForm: [
        {
          location: 'after',
          stylingMode: 'text',
          widget: 'dxButton',
          locateInMenu: 'never',
          text: 'Salva',
          icon: 'glyphicon mdi mdi-content-save-outline',
          event: 'generaGraficoEvent',
        },
        {
          location: 'after',
          stylingMode: 'text',
          widget: 'dxButton',
          locateInMenu: 'never',
          text: 'Annulla',
          icon: 'glyphicon glyphicon icon-annulla-form',
          event: 'annullaGeneraGrafico',
        },
      ],
      standardBtnBottom: [], //Rimuovo pulsanti footer default metodo 1
      disableEditForm: true, //Rimuovo pulsanti footer default metodo 2
    };

    this.userComponentService.setNewPopUp(guida, 'NewNicaFormComponent', null, '550', null, instancedData, false, true, 'Commenti grafico', 'center');
    let commentiGrafico = '';
    this.userComponentService.outputComponent.subscribe((res) => {
      console.log(res);
      if (res.formData && res.formData.commentiGrafico === null) {
        if (this.dettagli !== '') {
          res.formData.commentiGrafico = this.dettagli;
        }
      }
      if ((res.formData && res.formData.commentiGrafico) || (res.formData && res.formData.commentiGrafico === '')) {
        commentiGrafico = res.formData.commentiGrafico;
      }
      if (res.name === 'generaGraficoEvent' && res.guid == guida) {
        this.dettagli = commentiGrafico;
        return this.userComponentService.destroyCurrentOpenPopUp('NewNicaFormComponent');
      } else if (res.name == 'annullaGeneraGrafico' && res.guid == guida) {
        return this.userComponentService.destroyCurrentOpenPopUp('NewNicaFormComponent');
      }
    });
  }
  //!------------------------------------------------------------------------------------------------
  /**
   * Esegue una chiamata API per ottenere i dati, gestisce lo spinner di attesa e processa la risposta.
   *
   * Questa funzione prende un URL come input, effettua una chiamata API utilizzando il servizio `apiservice`,
   * e gestisce lo spinner durante l'attesa della risposta. In base ai dati ricevuti:
   * - Mostra o nasconde lo spinner.
   * - Determina se ci sono dati disponibili.
   * - Processa i dati della risposta per la visualizzazione nel grafico.
   *
   * Passaggi principali:
   * 1. Mostra uno spinner di caricamento per indicare che la chiamata API è in corso.
   * 2. Utilizza il metodo `GetApi` del servizio API per inviare una richiesta.
   * 3. Una volta ricevuta la risposta:
   *    - Nasconde lo spinner.
   *    - Se la risposta è vuota, imposta `isData` su `false` e interrompe l'elaborazione.
   *    - Altrimenti, imposta `isData` su `true` e chiama la funzione `processResponseForChart` per elaborare i dati.
   * 4. Gestisce eventuali errori:
   *    - Nasconde lo spinner.
   *    - Registra l'errore nella console e mostra un messaggio di avviso all'utente.
   *
   * @param {string} url - L'URL per la chiamata API.
   * @returns {void} Nessun valore restituito; i risultati vengono elaborati e assegnati internamente.
   */
  private async getApiData(url: string) {
    //mostra lo spinner di attesa
    this.spinner.show('spinChart');
    //aspetta la risposta alla chiamata api con l'url passato
    await this.apiservice
      .GetApi(url)
      .then((response: ResponseOdata) => {
        console.log('%cRisposta Query Odata: ', 'background-color:green;color:black', response);
        //nascondi lo spinner di attesa
        this.spinner.hide('spinChart');
        if (response.items.length <= 0) {
          this.isData = false;
          return;
        } else {
          this.isData = true;
          //processa la risposta per i dati del chart
          return this.processResponseForChart(response);
        }
      })
      .catch((error) => {
        this.spinner.hide('spinChart');
        console.error(error);
        return alert('Errore nella generazione dei dati', 'Errore');
      });
  }
  /**
   * Elabora i dati ricevuti dalla risposta API e li prepara per la visualizzazione in un grafico.
   *
   * Questa funzione esegue diversi passaggi per aggregare, calcolare e trasformare i dati:
   * 1. Estrae i valori iniziali e finali di registrazione (`startDate`, `endDate`) dalla URL OData.
   * 2. Determina il numero di giorni nel mese (se rilevante) per popolare dati mancanti.
   * 3. Aggiunge chiavi vuote ai dati per giorni o mesi mancanti, in base alla statistica selezionata.
   * 4. Itera sui dati ricevuti dalla risposta (`response.items`) e li raggruppa usando chiavi specifiche
   *    generate in base al tipo di statistica (`statistica`).
   * 5. Somma le quantità (`quantita`) per ciascuna chiave.
   * 6. Calcola le percentuali relative per ogni gruppo.
   * 7. Trasforma l'oggetto aggregato in un array e lo assegna come sorgente dati per il grafico.
   *
   * @param {any} response - La risposta ricevuta dal server contenente i dati da elaborare.
   * @returns {void | Promise<void>}
   */
  private processResponseForChart(response: any): void | Promise<void> {
    if (response && response.items) {
      // Calcola data inizio e data fine da urlOData
      const [startDate, endDate] = this.estraiDataRegistrazione();
      // Calcola il numero di giorni nel mese
      const daysInMonth = new Date(startDate.year, startDate.month, 0).getDate();
      //se statistica uguale al giorno/mese popola con i dati vuoti per rendere leggibile il grafico
      if (this.statistica === 4) {
        if (startDate.month === endDate.month) {
          this.isMonthUguali = true;
          // se mesi uguali itera attraverso tutti i giorni del mese e aggiungili se non presenti
          for (let day = 1; day <= daysInMonth; day++) {
            // Calcola il giorno della settimana
            const date = new Date(startDate.year, startDate.month - 1, day); // Mesi indicizzati da 0
            const daysOfWeekItalian = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
            const dayOfWeekItalian = daysOfWeekItalian[date.getDay()];
            // Modifica la chiave per includere il giorno della settimana
            const key = `${dayOfWeekItalian} ${String(day)}`;
            if (!this.dataObject[key]) {
              this.dataObject[key] = {
                argumentField: key,
                dataStored: [],
                idStatoFisico: null,
                statoFisico_Iniziali: null,
                statoFisico_Descrizione: null,
                isUrbano: null,
                riferimentoEER: null,
                EER: null,
                dataRegistrazione: `${day} ${this.capitalize(new Date(startDate.year, startDate.month - 1).toLocaleString('it-IT', { month: 'long' }))} ${startDate.year}`,
                idCliente: null,
                cliente_Descrizione: null,
                idProduttore: null,
                produttore_Descrizione_Soggetto: null,
                idTrasportatore: null,
                trasportatore_Descrizione_Soggetto: null,
                idDestinatario: null,
                destinatario_Descrizione_Soggetto: null,
                quantitaPercent: null,
                quantita: null,
              };
              continue;
            }
          }
        } else {
          //itera tutti i mesi e aggiungili se non presenti
          this.mesi.forEach((mese) => {
            if (!this.dataObject[mese]) {
              this.dataObject[mese] = {
                argumentField: mese,
                dataStored: [],
                idStatoFisico: null,
                statoFisico_Iniziali: null,
                statoFisico_Descrizione: null,
                isUrbano: null,
                riferimentoEER: null,
                EER: null,
                dataRegistrazione: mese,
                idCliente: null,
                cliente_Descrizione: null,
                idProduttore: null,
                produttore_Descrizione_Soggetto: null,
                idTrasportatore: null,
                trasportatore_Descrizione_Soggetto: null,
                idDestinatario: null,
                destinatario_Descrizione_Soggetto: null,
                quantitaPercent: null,
                quantita: null,
              };
            }
          });
        }
      }
      // cicla sulla risposta
      response.items.forEach((item: any) => {
        let key = '';

        //se statistica uguale a EER
        if (this.statistica === 1) {
          key = item.eer ? `${item.eer.toString()}` : null;
        }
        //se statistica uguale a EER + tipologia + stato fisico
        else if (this.statistica === 2) {
          key = `${item.eer}/${item.isUrbano}/${item.statoFisico_Iniziali}`;
        }
        //se statistica uguale a EER + riferimentoEER
        else if (this.statistica === 3) {
          key = `${item.eer}${item.riferimentoEER !== '' ? '/' + item.riferimentoEER : ''}`;
        }
        //se statistica uguale a giornaliero/mensile
        else if (this.statistica === 4) {
          if (startDate.month === endDate.month) {
            // Calcola il giorno della settimana
            const date = new Date(item.dataRegistrazione);
            const daysOfWeekItalian = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
            const dayOfWeekItalian = daysOfWeekItalian[date.getDay()];
            // se mesi uguali usa giorni
            key = `${dayOfWeekItalian} ${new Date(item.dataRegistrazione).getDate()}`;
          } else {
            // altrimenti usa mesi
            key = `${this.capitalize(new Date(item.dataRegistrazione).toLocaleString('it-IT', { month: 'long' }))}`;
          }
        }
        //se statistica uguale a cliente
        else if (this.statistica === 5) {
          key = item.cliente_Descrizione ? `${item.cliente_Descrizione}` : null;
        }
        //se statistica uguale a produttore
        else if (this.statistica === 6) {
          key = item.produttore_Descrizione_Soggetto ? `${item.produttore_Descrizione_Soggetto}` : null;
        }
        //se statistica uguale a trasportatore
        else if (this.statistica === 7) {
          key = item.trasportatore_Descrizione_Soggetto ? `${item.trasportatore_Descrizione_Soggetto}` : null;
        }
        //se statistica uguale a smaltitore
        else if (this.statistica === 8) {
          key = item.destinatario_Descrizione_Soggetto ? `${item.destinatario_Descrizione_Soggetto}` : null;
        }
        //se non ho la chiave salto l'oggetto
        if (key === null) {
          return;
        }
        //        console.log(`Oggetto con chiave ${key}: `,item.quantitaKg)
        //popola l'oggetto con la chiave appropriata con i dati della risposta e popola il contenitore
        if (!this.dataObject[key]) {
          this.dataObject[key] = {
            argumentField: key,
            dataStored: [],
            idStatoFisico: item.idStatoFisico,
            statoFisico_Iniziali: item.statoFisico_Iniziali,
            statoFisico_Descrizione: item.statoFisico_Descrizione,
            isUrbano: item.isUrbano ? 'Urbano' : 'Non Urbano',
            riferimentoEER: item.riferimentoEER,
            EER: item.eer,
            dataRegistrazione: item.dataRegistrazione,
            idCliente: item.idCliente,
            cliente_Descrizione: item.cliente_Descrizione,
            idProduttore: item.idProduttore,
            produttore_Descrizione_Soggetto: item.produttore_Descrizione_Soggetto,
            produttore_Descrizione_Sede: item.produttore_Descrizione_Sede,
            idTrasportatore: item.idTrasportatore,
            trasportatore_Descrizione_Soggetto: item.trasportatore_Descrizione_Soggetto,
            idDestinatario: item.idDestinatario,
            destinatario_Descrizione_Soggetto: item.destinatario_Descrizione_Soggetto,
            quantitaPercent: null,
            quantita: null,
          };
        }

        // somma le quantità negli oggetti con chiavi uguali controllando se è definito
        if (this.dataObject[key].quantita !== null) {
          this.dataObject[key].quantita += parseFloat(item.quantitaKg);
        } else {
          this.dataObject[key].quantita = parseFloat(item.quantitaKg);
        }
        this.dataObject[key].dataStored.push(item);
      });
      //      console.log('%cDati Generati: ','background-color:orange;color:black',this.dataObject)
      // Converti l'oggetto in un array
      let elaboratedData = Object.values(this.dataObject);
      // calcola percentuali di movimenti
      elaboratedData = this.calcolaPercentuali(elaboratedData);
      //      elaboratedData.forEach(element => {
      //        console.log(`Ritorno con ${element.argumentField}: `,element.quantita)
      //      });
      elaboratedData.forEach((elemento) => {
        elemento.argumentField += ` - ${elemento.quantita !== null ? elemento.quantita.toLocaleString('it-IT') : 0} Kg`;
      });
      // Assegna i dati elaborati alla fonte di dati del grafico
      this.chartDataSource = elaboratedData;
      console.log('%cDati Passati al Chart: ', 'background-color:orange;color:black', this.chartDataSource);
      return this.cdr.detectChanges();
    } else {
      return alert('Errore nella generazione dei dati, ti preghiamo riprovare', 'Errore');
    }
  }
  /**
   * Estrae i valori `daData` e `aData` dall'URL OData e li restituisce come un array di oggetti data.
   *
   * Questa funzione analizza la stringa `urlOdata` per trovare le date associate al campo `dataRegistrazione`.
   * Le date vengono cercate nella sezione `$filter` della query e restituite in un array di oggetti contenenti
   * giorno, mese e anno.
   *
   * Passaggi principali:
   * 1. Decodifica la query URL per assicurarsi che i caratteri speciali siano leggibili.
   * 2. Estrae la parte della query relativa al filtro (`?$filter=`).
   * 3. Utilizza una espressione regolare (`regex`) per identificare tutte le date che seguono il campo `dataRegistrazione`
   *    e gli operatori `ge` (greater or equal) o `le` (less or equal).
   * 4. Itera sui risultati trovati con `regex.exec` e converte le date in un array di oggetti `DateRegistrazioni`,
   *    ognuno con giorno, mese e anno.
   * 5. Restituisce l'array delle date trovate.
   *
   * @returns {DateRegistrazioni[]} Un array di oggetti `DateRegistrazioni`, ciascuno contenente:
   *  - `day` (numero del giorno)
   *  - `month` (numero del mese, da 1 a 12)
   *  - `year` (anno)
   */
  private estraiDataRegistrazione(): DateRegistrazioni[] {
    // Decodifica della query per renderla leggibile
    const decodedQuery = decodeURIComponent(this.urlOdata);
    // Estrazione dei dati di filter
    const filterPart = decodedQuery.split('?$filter=')[1];
    // Regex per trovare le date di dataRegistrazione
    const dateRegex = /dataRegistrazione\s+(ge|le)\s+(\d{4}-\d{2}-\d{2})/g;
    const dates: DateRegistrazioni[] = [];
    let match;
    // Cerca tutte le date che corrispondono alla regex
    while ((match = dateRegex.exec(filterPart)) !== null) {
      //inserisci nell'array le date di registrazione
      dates.push({ day: new Date(match[2]).getDate(), month: new Date(match[2]).getMonth() + 1, year: new Date(match[2]).getFullYear() });
    }
    //ritorna array di date
    return dates;
  }
  /**
   * Estrae la clausola `orderby` da una stringa URL OData.
   *
   * Questa funzione analizza la proprietà `urlOdata` per individuare
   * la clausola `orderby`, restituendo il valore corrispondente.
   *
   * Passaggi principali:
   * 1. Trova la posizione della clausola `&orderby=` all'interno della stringa.
   * 2. Se la clausola non è presente, restituisce una stringa vuota.
   * 3. Estrae la parte successiva a `&orderby=` fino al successivo separatore `&`.
   * 4. Se non è presente un separatore `&` successivo, restituisce tutto il contenuto rimanente.
   *
   * @returns {string} La stringa contenente la clausola `orderby` o una stringa vuota se non presente.
   */
  private estraiOrderBy(): string {
    //trova la posizione dell'orderby
    const orderByIndex = this.urlOdata.indexOf('&orderby=');
    //ritorna se non presente
    if (orderByIndex === -1) return '';
    // trova i valori dell'orderby
    const orderByPart = this.urlOdata.substring(orderByIndex + '&orderby='.length);
    // trova il separatore &
    const nextSeparatorIndex = orderByPart.indexOf('&');
    //ritorna i dati giusti
    return nextSeparatorIndex !== -1 ? orderByPart.substring(0, nextSeparatorIndex) : orderByPart;
  }
  /**
   * Genera un titolo descrittivo basato sul valore della clausola `orderby`.
   *
   * Questa funzione riceve un valore di `orderby` (solitamente proveniente da una URL OData)
   * e restituisce un titolo appropriato per rappresentare il significato del valore.
   *
   * Passaggi principali:
   * 1. Utilizza un `switch` per confrontare il valore di `orderbyValue`.
   * 2. In base al valore, restituisce una stringa descrittiva corrispondente.
   * 3. Se il valore non è riconosciuto, restituisce una stringa vuota.
   *
   * Casi supportati:
   * - `'eer'`: Restituisce il titolo "E.E.R".
   * - `'eer,idStatoFisico,isUrbano'`: Restituisce "E.E.R - Tipologia - Stato Fisico".
   * - `'eer,riferimentoEER'`: Restituisce "E.E.R - Riferimento".
   * - `'dataRegistrazione'`: Restituisce "Data di Registrazione".
   * - `'idCliente'`: Restituisce "Cliente".
   * - `'idProduttore'`: Restituisce "Produttore".
   * - `'idTrasportatore'`: Restituisce "Trasportatore".
   * - `'idDestinatario'`: Restituisce "Smaltitore".
   * - Default: Restituisce una stringa vuota.
   *
   * @param {string} orderbyValue - Il valore della clausola `orderby`.
   * @returns {string} Un titolo descrittivo per il valore `orderby`, o una stringa vuota se non riconosciuto.
   */
  private processOrderByTitle(orderbyValue: string): string {
    //prendo i valori dopo l'orderby e ritorno un titolo appropriato nei vari casi
    switch (orderbyValue) {
      case 'eer':
        return 'E.E.R';
      case 'eer,idStatoFisico,isUrbano':
        return 'E.E.R + Tipologia + Stato Fisico';
      case 'eer,riferimentoEER':
        return 'E.E.R + Riferimento';
      case 'dataRegistrazione':
        const date: DateRegistrazioni[] = this.estraiDataRegistrazione();
        if (date[0].month === date[1].month) {
          return 'Giorni';
        } else {
          return 'Mese';
        }
      case 'idCliente':
        return 'Cliente';
      case 'idProduttore':
        return 'Produttore';
      case 'idTrasportatore':
        return 'Trasportatore';
      case 'idDestinatario':
        return 'Smaltitore';
      default:
        return '';
    }
  }
  /**
   * Calcola le percentuali e i totali per i dati elaborati.
   *
   * Questa funzione prende un array di dati del grafico, calcola la percentuale di ciascun elemento
   * rispetto al totale della quantità, e individua il valore massimo di quantità presente.
   *
   * Passaggi principali:
   * 1. **Calcolo del totale**:
   *    - Somma tutti i valori di `quantita` presenti nell'array `elaboratedData`.
   * 2. **Determinazione del massimo**:
   *    - Trova il valore più alto di `quantita` tra tutti gli elementi.
   *    - Assegna questo valore alla proprietà `rangeMaxQuantita` (probabilmente per scopi di visualizzazione).
   * 3. **Calcolo delle percentuali**:
   *    - Per ogni elemento, calcola la percentuale relativa usando la formula:
   *    - Arrotonda il risultato con `Math.round`.
   *    - Se il totale (`totQuantitaKg`) è zero, assegna 0% a tutti gli elementi.
   * 4. Restituisce l'array aggiornato con i campi `quantitaPercent` modificati.
   *
   * @param {DatiChart[]} elaboratedData - Array di oggetti contenenti i dati del grafico.
   * @returns {DatiChart[]} L'array aggiornato con le percentuali calcolate per ogni elemento.
   */
  private calcolaPercentuali(elaboratedData: DatiChart[]) {
    // Calcola i totali per quantita
    const totQuantitaKg = elaboratedData.reduce((total, item) => total + Number(item.quantita), 0);
    this.totQuantitaKg = totQuantitaKg;
    this.subTitleLegend = ` Quantità totale: ${this.totQuantitaKg.toLocaleString('it-IT')} Kg`;
    // Trova la quantità più alta
    this.rangeMaxQuantita = elaboratedData.reduce((max, item) => Math.max(max, Number(item.quantita)), 0);
    // Calcola e assegna le percentuali
    elaboratedData.forEach((item) => {
      item.quantitaPercent = totQuantitaKg > 0 ? Math.round((Number(item.quantita) * 100) / totQuantitaKg) : 0;
    });
    // ritorna il nuovo array con le percentuali
    return elaboratedData;
  }

  private popUpGrid(data: any[]) {
    console.log(data);
    const guida = Math.random().toString().replace('0.', '') + 'dettagliStatistiche';
    let instancedData = {
      campoTabRif: '',
      masterKey: 'id',
      keyUnique: '',
      selectRow: 'none',
      rowAlternationEnabled: true,
      name: 'DettagliStatisticaRifiuti',
      titolo: 'DettagliStatisticaRifiuti',
      remoteOperations: false,
      allowUpdating: false,
      allowDeleting: false,
      allowAdding: false,
      searchAndSelect: false, //Cerca Valore e seleziona
      searchType: 'contains',
      showColBlank: true,
      toolbarButtonsBottomLeft: null,
      toolbarButtonsBottomRight: [0],
      isOdata: false,
      gridHeight: 600,
      classe: 'p-3 rounded gridOfWidget',
      dxosorting: 'multiple',
      overrideDataSource: null,
      concatDataField: null,
      service: 'datiInGrid',
      api: '',
      isStatic: true,
      myDsStatic: data['dataStored'],
      isDataStatic: true,
      columnHidingEnabled: true,
      modifica: false,
      aggiungi: false,
      elimina: false,
      isExportDocxAvailable: true,
      isExportPDFAvailable: true,
      isExportExcelAvailable: true,
      showHeader: false,
      showFooter: false,
      dxocolumnchooser: false,
      ricerca: false,
      soloRicercaGlobale: true,
      allowColumnResizing: true,
    };

    this.userComponentService.setNewPopUp(guida, 'NicaAnagraficaComponent', null, '1200', null, instancedData, false, true, 'Dettagli Statistiche', 'top');
  }
}
